<template>
	<div>
		<h6 class="headline pa-2 mb-3 text-center">
			GST Invoice Verification
		</h6>
		<v-layout justify-center row wrap>
			<v-flex>
				<v-autocomplete
					v-model="selectedYear"
					label="Select Year"
					:items="filterYears"
					:autcomplete="false"
					placeholder="Year"
					class="text-field-wrapper pt-4"
					clearable
				/>
			</v-flex>
			<v-flex>
				<v-autocomplete
					v-model="selectedMonth"
					label="Select Month"
					:items="filterMonths"
					:autcomplete="false"
					placeholder="Month"
					class="text-field-wrapper pt-4"
					clearable
				/>
			</v-flex>
		</v-layout>
		<v-layout justify-center>
			<v-btn
				round
				:dark="!!selectedYear && !!selectedMonth"
				:color="themeInputColor"
				:disabled="!selectedYear || !selectedMonth"
				:loading="isInvoiceFetching"
				@click="fetchPendingInvoices"
			>
				Get Pending Invoices
			</v-btn>
		</v-layout>
		<v-layout justify-center>
			<v-btn
				round
				:dark="!!selectedYear && !!selectedMonth"
				:color="themeInputColor"
				:disabled="!selectedYear || !selectedMonth"
				:loading="isBulkListDownloading"
				@click="fetchBulkList"
			>
				Download Monthly Invoice CSV
			</v-btn>
		</v-layout>
		<v-card
			class="white--text pa-2 d-flex justify-space-between align-center body-2 full-width text-center"
			ripple
			:color="themeInputColor"
		>
			<div style="width: 40%">Name/UserId</div>
			<div style="width: 30%">City/State</div>
			<div style="width: 30%">Action</div>
		</v-card>
		<v-card
			v-if="!pendingInvoices.length"
			class="text-center pa-4 body-2"
			:loading="true"
		>
			<div>No pending invoices for verification</div>
		</v-card>
		<v-card
			v-for="{
				retailerName = '-',
				city = '-',
				state = '-',
				invoiceId,
				dstrId,
				month,
				year
			} in pendingInvoices"
			:key="invoiceId"
			class="pa-2"
		>
			<div class="d-flex justify-space-between align-center full-width">
				<div style="width: 40%">
					<div class="title">{{ retailerName }}</div>
					<div class="caption">{{ dstrId }}</div>
				</div>
				<div class="text-center" style="width: 30%">
					<div class="body-2">{{ city }}</div>
					<div>{{ state }}</div>
					<div class="body-2">
						{{ MONTHS[month].substr(0, 3) }}-{{
							String(year).substr(2, 2)
						}}
					</div>
				</div>
				<div class="text-right" style="width: 30%">
					<v-btn
						:color="themeInputColor"
						@click.stop="openInvoiceVerifyModal(invoiceId)"
						class="white--text rounded-card"
						small
						>Action</v-btn
					>
				</div>
			</div>
		</v-card>
		<v-dialog width="600px" persistent v-model="invoiceModal">
			<div class="white pos-rel pa-2 rounded-card">
				<v-btn
					small
					flat
					icon
					@click.stop="closeInvoiceVerifyModal"
					class="float-right"
				>
					<v-icon size="24">close</v-icon>
				</v-btn>
				<h6 class="headline text-center">GST Invoice</h6>
				<pdf
					v-if="this.selectedDstr.url"
					:src="{
						url: this.selectedDstr.url
					}"
					:key="this.selectedDstr.url"
					:resize="true"
				>
					<template slot="loading">
						loading content here...
					</template>
				</pdf>
				<v-text-field
					v-model="remarks"
					label="Remarks"
					placeholder="Remarks (if rejected)"
					class="text-field-wrapper mx-4 pt-4 mb-3"
					filled
				/>
				<div class="d-flex justify-space-between align-center">
					<v-btn
						color="red darken-3"
						@click.stop="verifyInvoice(true)"
						class="white--text body-2 rounded-card py-3"
						small
						:loading="verifyingInvoice === 2"
						>Reject</v-btn
					>
					<v-btn
						color="green darken-1"
						@click.stop="verifyInvoice()"
						class="white--text body-2 rounded-card py-3"
						small
						:disabled="!!remarks"
						:loading="verifyingInvoice === 1"
						>Approve</v-btn
					>
				</div>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import pdf from "pdfvuer";
import {
	GET_PENDING_INVOICES,
	FETCH_MONTHLY_DSTR_INVOICE,
	VERIFY_INVOICE,
	SHOW_ALERT
} from "../../../store/action-types";
import { THEME_INPUT_COLOUR, MONTHS } from "../../constants";
import { __fileDownload } from "../../../utils";

export default {
	props: ["appType"],
	components: {
		pdf
	},
	data() {
		return {
			pendingInvoices: [],
			invoiceModal: false,
			selectedDstr: {},
			verifyingInvoice: 0,
			remarks: "",
			themeInputColor: THEME_INPUT_COLOUR,
			showOptions: false,
			MONTHS,
			selectedYear: "",
			selectedMonth: "",
			isInvoiceFetching: false,
			isBulkListDownloading: false
		};
	},
	computed: {
		filterYears() {
			return [2021, 2022];
			// const currentYear = new Date().getFullYear();
			// return [currentYear - 1, currentYear];
		},
		filterMonths() {
			return MONTHS;
			// return MONTHS.slice(0, new Date().getMonth());
		}
	},
	methods: {
		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		},
		openInvoiceVerifyModal(id) {
			this.selectedDstr =
				this.pendingInvoices.filter(dstr => dstr.invoiceId === id)[0] ||
				{};
			this.invoiceModal = true;
		},
		closeInvoiceVerifyModal() {
			this.invoiceModal = false;
		},
		fetchPendingInvoices() {
			if (this.isInvoiceFetching) {
				return;
			}
			this.isInvoiceFetching = true;
			this.$store
				.dispatch(GET_PENDING_INVOICES.dispatch, {
					type: "finance",
					status: "pending",
					invoiceType: this.appType,
					month: MONTHS.findIndex(
						month => month === this.selectedMonth
					),
					year: this.selectedYear
				})
				.catch(() => {})
				.then(data => {
					this.pendingInvoices = data || [];
				})
				.finally(() => {
					this.isInvoiceFetching = false;
				});
		},
		verifyInvoice(reject = false) {
			this.verifyingInvoice = reject + 1;
			const { invoiceId = "" } = this.selectedDstr;
			this.$store
				.dispatch(VERIFY_INVOICE.dispatch, {
					invoiceId,
					status: !reject ? "accepted" : "rejected",
					...(reject ? { remarks: this.remarks } : {})
				})
				.catch(() => {})
				.finally(() => {
					this.fetchPendingInvoices();
					this.verifyingInvoice = 0;
					this.invoiceModal = false;
				});
		},
		fetchBulkList() {
			if (this.isBulkListDownloading) {
				return;
			}
			this.isBulkListDownloading = true;
			this.$store
				.dispatch(FETCH_MONTHLY_DSTR_INVOICE.dispatch, {
					month: MONTHS.findIndex(
						month => month === this.selectedMonth
					),
					year: this.selectedYear,
					invoiceType: this.appType
				})
				.then(data => {
					if (data) {
						const { code, msg } = data;
						if (code === 200) {
							const { status, fileUrl } = msg;
							if (status === "success") {
								__fileDownload(fileUrl);
							}
						}
					} else {
						this.showAlert("No data for the specified month");
					}
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isBulkListDownloading = false;
				});
		}
	}
};
</script>
<style scoped>
.rounded-card {
	border-radius: 8px;
}
.float-right {
	position: absolute;
	top: 2px;
	right: 2px;
}
</style>
